import moment from 'moment-timezone';
import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { AiOutlinePhone, AiOutlineMail, AiOutlineUser } from 'react-icons/ai';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import mapIcon from "../../../../../utils/map_icon.js";
import { FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import './styles.css';

function DescOne({ event }) {
    const { t } = useTranslation();

    const maskPhone = (original) => {
        const x = original.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    return (
        <Tabs selectedTabClassName="show" selectedTabPanelClassName="active show">
            <div className="product-details-tab">
                <TabList className="nav nav-pills justify-content-center">
                    <Tab className="nav-item">
                        <span className="nav-link"> {t("DescOne.additionalInformation")} </span>
                        
                    </Tab>
                    {event.organizer &&
                        <Tab className="nav-item">
                            {/* <span className="nav-link"> Contact</span> */}
                            <span className="nav-link"> {t("DescOne.contact")} </span>
                        </Tab>}

                    <Tab className="nav-item">
                        {/* <span className="nav-link"> Refund Procedure</span> */}
                        <span className="nav-link"> {t("DescOne.refundProcedure")} </span>
                    </Tab>

                </TabList>

                <div className="tab-content">
                    <TabPanel className="tab-pane">
                        <div className="row row-responsive" style={{justifyContent: "center"}}>
                            <div className="product-desc-content col-10" >
                                <div className="row row-responsive" style={{ alignItems: "center", marginTop: "-20px" }}>
                                    <i className="icon-calendar" style={{ fontSize: "4rem", marginRight: "10px" }}></i>
                                    <div>
                                        <p>{moment(event.start_at).utc().format("L, LT ")}</p>
                                        <p>{moment(event.finish_at).utc().format("L, LT ")}</p>
                                    </div>
                                </div>
                                {event.address &&
                                    <div>
                                        <div className="row row-responsive" style={{ alignItems: "center", textAlign:"center", marginTop: "-20px", padding:"15px 0 15px 0" }}>
                                            <i className="icon-map-marker" style={{ fontSize: "4rem", marginRight: "10px" }}></i>
                                            <div style={{}}>
                                                <p>{event.address.address} {event.address.city}, {event.address.state} - {event.address.local_name}</p>
                                                <p></p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row row-responsive" style={{ alignItems: "center", marginTop: "-20px" }}>
                                    <i className="icon-mail-reply" style={{ fontSize: "4rem", marginRight: "10px" }}></i>
                                    <div>
                                        {/* <p>Refund Policy: {event.refundable ? "Refundable" : "Not refundable"}</p> */}
                                        <p>{t("DescOne.refundPolicy")}: {event.refundable ? t("DescOne.refundable") : t("DescOne.notRefundable")}</p>
                                        
                                    </div>
                                </div>
                                <div className="row row-responsive" style={{ alignItems: "center" }}>
                                    <FaInstagram style={{ fontSize: "3rem", marginRight: "15px", marginLeft:"5px" }} />
                                    <div>
                                        <a  href={event.instagram_link} target="_blank" rel="noopener noreferrer"><p className='instagram_link'>{event.instagram_link}</p></a>
                                        
                                    </div>
                                </div>
                                {event && event.address && event.address.coordinates && event.address.coordinates.lat !== null && 
                                    <div className="row row-responsive" style={{marginTop:"30px"}}>
                                        <a id="open-in-maps" href={`https://maps.google.com/?q=${event.address.coordinates.lat},${event.address.coordinates.long}`} target="_blank">
                                            <i className="icon-map-marker" style={{ fontSize: "1.4rem", marginRight: "5px" }}></i>
                                            {/* <span >Open in Maps</span> */}
                                            <span >{t("DescOne.openInMaps")}</span>
                                        </a>
                                    </div>
                                }
                            </div>
                            <div className="col-12 col-md-6 mt-2 mt-md-0">
                                {event.address.coordinates && event.address.coordinates.lat ?
                                    <div style={{ display: 'block' }}>
                                        <div id="location-event">
                                            <fieldset>
                                                <MapContainer
                                                    style={{ width: '100%', height: 280 }}
                                                    center={[event.address.coordinates.lat, event.address.coordinates.long]}
                                                    zoom={13}
                                                >
                                                    <TileLayer url="https://a.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                                    {
                                                        <Marker
                                                            interactive={false}
                                                            icon={mapIcon}
                                                            position={[event.address.coordinates.lat, event.address.coordinates.long]}
                                                        />
                                                    }
                                                </MapContainer>
                                            </fieldset>
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>

                    </TabPanel>

                    {event.organizer && <TabPanel className="tab-pane">
                        <div>
                            {event.organizer.name &&
                                <h3>
                                    {event.organizer.name}
                                </h3>}
                            <ul style={{ listStyle: 'none' }}>
                                {event.organizer.contact_name &&
                                    <li >
                                        <AiOutlineUser /> &nbsp;
                                        {event.organizer.contact_name}
                                    </li>}
                                {event.organizer.contact_email &&
                                    <li>
                                        <AiOutlineMail /> &nbsp;
                                        {event.organizer.contact_email}
                                    </li>}
                                {event.organizer.contact_phone &&
                                    <li >
                                        <AiOutlinePhone /> &nbsp;
                                        {maskPhone(event.organizer.contact_phone)}
                                    </li>}
                            </ul>
                        </div>
                    </TabPanel>}

                    <TabPanel className="tab-pane">
                        <div className="product-desc-content">
                            <div className="row row-responsive" style={{ alignItems: "center", marginTop: "-20px" }}>
                                <i className="icon-info" style={{ fontSize: "4rem", marginRight: "10px" }}></i>

                                <div class="row row-responsive" style={{ padding: "10px 50px" }}>
                                    <p>
                                        {/* Reply to the email you received the ticket (noreply@groovootickets.com), informing the reason of your request. The request analysis period is 0 to 5 working days, and if accepted, depending on the event policy and approval from the event organizer, the refund will be credited to the same credit card used in the purchase, after an estimated period of 0 to 10 working days, depending on of banking procedures. */}
                                        {t("DescOne.replyEmail")}
                                    </p>


                                </div>

                            </div>
                        </div>
                    </TabPanel>

                </div>
            </div>
        </Tabs>
    );
}

export default DescOne;